import { DateTime } from "luxon";

/***** Response Type ****/
export type IssueResponse = {
  issue: IssueKeyType;
  issueKey?: string;
  "tardy-timestamp"?: DateTime | string;
  "tardy-offset"?: number;
};

export type IssueKeyType = (typeof IssueType)[keyof typeof IssueType];

export const IssueType = {
  NoShowUnConfirmed: "ISSUE_NO_SHOW_UNCONFIRMED",
  NoShowConfirmed: "ISSUE_NO_SHOW_CONFIRMED",
  LunchLate: "ISSUE_LUNCH_LATE",
  Late: "ISSUE_LATE",
  SubLeftEarly: "ISSUE_SUB_LEFT_EARLY",
  UrgentConcern: "ISSUE_URGENT_ON_CAMPUS",
} as const;

export class IssueModel {
  private issue?: IssueResponse;

  constructor(issue: IssueResponse) {
    this.issue = issue;
  }

  get issueKey() {
    return this.issue?.issue;
  }

  get tardyTimestamp() {
    const isoString = this.issue?.["tardy-timestamp"] as string;

    return DateTime.fromISO(isoString);
  }
}
